module.exports = __webpack_public_path__ + "img/2_187.05b01257.png";